import ct from "class-types.macro";

export const listClasses = ct(
  "rounded-md",
  "inline-block",
  "font-semibold",
  "h-7-1/2",
  "list-none",
  "m-0",
  "w-auto",
);

export const listItemClasses = ct("inline-block", "leading-4", "align-top");

export const currentLinkClasses = ct(
  "text-white",
  "shadow-inner-green",
  "bg-green-gradient",
);

export const linkClasses = ct(
  "border-gray-400",
  "hover:border-green-800",
  "border-solid",
  "border",
  "border-r-0",
  "box-border",
  "flex",
  "items-center",
  "justify-center",
  "font-semibold",
  "h-7-1/2",
  "text-sm",
  "leading-none",
  "p-0",
  "fill-current",
  "hover:text-white",
  "w-7-1/2",
  "hover:shadow-inner-green",
  "bg-gray-gradient",
  "hover:bg-green-gradient",
);
